import React, { useState, useCallback, useEffect } from 'react';
import EdgeOrREST from '../../EdgeOrREST';
import Notification from '../../components/shared/notification.component';
import {
    makeStyles,
    Button,
    TextField,
    Checkbox,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Paper,
    Tabs,
    Tab,
    Box,
    Tooltip,
} from '@material-ui/core';
import TreeItem from '@material-ui/lab/TreeItem';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch, useSelector } from 'react-redux';
import PhotometricAttributeSelector from '../photometice-attributes-menu/photometric-attribute-selector.component';
import PhotometricAttributeStreetlightSelector from '../photometice-attributes-menu/photometric-attribute-streetlight-selector.component';
import PhotometricMediaUpload from '../photometric-media-upload.component';
import tourActions from '../../store/actions/tourActions';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function Luminaire(props) {
    const classes = props.useTreeItemStyles();
    const { labelText, labelIcon: LabelIcon, removeLuminaire: RemoveInfo, color, bgColor, luminaireId, selectedNode, ...other } = props;
    const [selected, setSelected] = React.useState(false);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [luminDescription, setLuminDescription] = React.useState(props.description);
    const [attributeParams, setAttributeParams] = useState({});
    const [mediaUpload, setMediaUpload] = React.useState({
        data: [],
        fileNames: [],
        groupId: props.groupId,
        luminaireId: props.luminaireId,
        uploadType: []
    });
    const [snack, setSnack] = React.useState({
        open: false
    });
    const state = useSelector(state => state)
    const dispatch = useDispatch()
    const handleClose = () => {
        setSnack({
            ...snack,
            open: false
        });
    };

    const isSelected = luminaireId === selectedNode;
    // console.log("props in luminaire", props, isSelected);

    const [editTab, setEditTabIndex] = React.useState(0);
    const handleEditTab = (event, value) => {
        setEditTabIndex(value);
    };


    const handleEditDialogClose = () => {
        setOpenEdit(false);
    };

    const onClickEditLuminaire = () => {
        if (state.EnabledTour.helpMode) {
            dispatch(tourActions.UpdateHelpURL({ helpURL: "Edit Group" }))
            const video = document.getElementById("help-video")
            video.load();
            dispatch(tourActions.UpdateHelpText({ helpText: "This button lets you edit your group or luminaire." }))
        } else {
            setOpenEdit(true);
            setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
        }
    };

    const editLuminaire = () => {
        console.log("props.nodeId: ", props.nodeId);
        EdgeOrREST(null, 'UPDATE_LUMINAIRE_DESCRIPTION', onUpdateLuminDescription, { 'id': props.nodeId, description: luminDescription });
        EdgeOrREST(null, 'UPDATE_ATTRIBUTES_TO_LUMINAIRE', onUpdateLuminaireAttributes, { 'id': props.luminaireId, attributeParams: attributeParams });
        EdgeOrREST(null, 'UPLOAD_MEDIA_FOR_LUMINAIRES', onUploadMedia, mediaUpload);
        setOpenEdit(false);
        setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
    };

    const onUpdateLuminDescription = (response) => {
        console.log("onUpdateLuminDescription", response);
    };

    const onUploadMedia = (response) => {
        console.log("onUploadMedia", response);
        if (response.status == 200) {
            setSnack({
                open: true,
                message: "Files uploaded successfully",
                severity: 'success'
            });
        } else {
            setSnack({
                open: true,
                message: response.status + response.message,
                severity: 'error'
            });
        }
    };

    const onUpdateLuminaireAttributes = (response) => {
        console.log("onUpdateLuminaireAttributes", response);
        if (response.status == 200) {
            setSnack({
                open: true,
                message: "Luminaire attributes update successful.",
                severity: 'success'
            });
        } else {
            setSnack({
                open: true,
                message: response.status + response.message,
                severity: 'error'
            });
        }
        other.resetGotChildren();
        props.forceUpdate();
    };

    const handleAttributeParams = useCallback((attributeParams) => {
        setAttributeParams(attributeParams);
    }, []);

    const handleMediaUpload = useCallback((mediaUpload) => {
        setMediaUpload(mediaUpload);
    }, []);

    let dragActive = false;

    return (
        <>
            <Dialog
                open={openEdit}
                onClose={handleEditDialogClose}
                classes={{ paper: classes.dialogPaper }}
                className='manageStep10'
            >
                <DialogTitle>Edit Luminaire</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        label="Enter Description"
                        type="text"
                        fullWidth
                        id="standard-name"
                        defaultValue=""
                        value={luminDescription}
                        onChange={(e) => setLuminDescription(e.target.value)}
                        inputProps={{ maxLength: 250 }}
                    />
                    <Paper square>
                        <Tabs
                            value={editTab}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            onChange={handleEditTab}
                            aria-label="disabled tabs example"
                        >
                            <Tab index={0} name="lighting" label="street lighting"  {...a11yProps(0)} value={0} />
                            {/* <Tab index={1} label="Spektd" {...a11yProps(1)} value={1} /> */}
                        </Tabs>
                    </Paper>
                    <TabPanel value={editTab} index={0}>
                        <PhotometricAttributeStreetlightSelector handleAttributeParams={handleAttributeParams} editLumin={true} luminaireId={props.luminaireId} parentGroupId={other.parentId} />
                    </TabPanel>
                    {/* <TabPanel value={editTab} index={1}>
                        <PhotometricAttributeSelector handleAttributeParams={handleAttributeParams} editLumin={true} luminaireId={other.luminaireId} parentGroupId={other.parentId} />
                        <PhotometricMediaUpload groupId={props.parentId} luminaireId={props.luminaireId} handleMediaUpload={handleMediaUpload} />
                    </TabPanel> */}
                </DialogContent>
                <div style={{ textAlign: "right", margin: 10 }}>
                    <Button variant="contained" color="primary" onClick={editLuminaire}>
                        Save
                    </Button>
                </div>
            </Dialog>
            <TreeItem
                label={
                    <div className={classes.labelRoot} style={isSelected ? { background: 'lightgreen' } : {}} >
                        <LabelIcon color="inherit" className={classes.labelIcon} />
                        <Typography variant="body2" className={classes.labelText}>
                            {labelText}
                        </Typography>
                        <Typography variant="caption" color="inherit">
                            <Tooltip title="Edit Luminaire">
                                {props.isCopy == null || props.isCopy != 1 ? <EditIcon color="inherit" className={classes.label} onClick={onClickEditLuminaire} /> : <></>}
                            </Tooltip>
                            <Checkbox
                                style={{ padding: '0px' }}
                                checked={props.checked}
                                color="primary"
                                onMouseDown={e => {
                                    if (e.button === 0) {
                                        window._dragCheckboxStart = true;
                                        window._dragCheckboxMoved = false;
                                        window.isDraggingCheckbox = false;
                                        window._dragCheckboxTimer = setTimeout(() => {
                                            window.isDraggingCheckbox = true;
                                            props.onSelectStart(props.nodeId, props.checked);
                                        }, 150); // 150ms threshold for drag
                                    }
                                }}
                                onMouseMove={e => {
                                    if (window._dragCheckboxStart && !window.isDraggingCheckbox) {
                                        clearTimeout(window._dragCheckboxTimer);
                                        window.isDraggingCheckbox = true;
                                        props.onSelectStart(props.nodeId, props.checked);
                                    }
                                }}
                                onMouseEnter={() => {
                                    if (window.isDraggingCheckbox) {
                                        props.onSelectHover(props.nodeId);
                                    }
                                }}
                                onMouseUp={e => {
                                    clearTimeout(window._dragCheckboxTimer);
                                    if (!window.isDraggingCheckbox) {
                                        // Quick mouse up: treat as single click
                                        props.onSingleCheck(props.nodeId, !props.checked);
                                    }
                                    window._dragCheckboxStart = false;
                                    window.isDraggingCheckbox = false;
                                    window._dragCheckboxMoved = false;
                                    props.onSelectEnd();
                                }}
                                onClick={e => {
                                    // Prevent double toggle, single click handled in onMouseUp
                                    e.stopPropagation();
                                }}
                                readOnly
                            />
                        </Typography>
                    </div>
                }
                style={{
                    '--tree-view-color': color,
                    '--tree-view-bg-color': bgColor,
                }}
                classes={{
                    root: classes.root,
                    content: classes.content,
                    expanded: classes.expanded,
                    selected: classes.selected,
                    group: classes.group,
                    label: classes.label,
                }}
                {...other}
            />
            <Notification onClose={handleClose} open={snack.open} severity={snack.severity} message={snack.message}></Notification>
        </>

    );
}

export default React.memo(Luminaire);